/** Product name — change only here if the display name must be updated later. */
export const SOFTWARE_NAME = 'ZeroCrypt' as const;

/** Full document title for browser tab + SEO (do not shorten to product name only). */
export const SITE_TITLE =
  'ZeroCrypt — Local File & Text Encryption in Your Browser' as const;

/**
 * Canonical public site URL (no trailing slash).
 * Override at build time with VITE_SITE_URL for correct social/SEO absolute links.
 */
export const SITE_URL = (
  typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL
    ? String(import.meta.env.VITE_SITE_URL)
    : 'https://zerocrypt.pentaframe.it'
).replace(/\/$/, '') as string;

/** Company / publisher identity (footer & about). */
export const COMPANY_NAME = 'Pentaframe' as const;
export const COMPANY_URL = 'https://www.pentaframe.it' as const;
export const COMPANY_LOGO_SRC = '/brand/pentaframe-logo.png' as const;
export const COMPANY_MARK_SRC = '/brand/pentaframe-mark.svg' as const;
export const OG_IMAGE_SRC = '/brand/og-image.png' as const;

export const SITE_DESCRIPTION =
  'ZeroCrypt is a privacy-first encryptor for files and text. AES-256-GCM and Argon2id run entirely in your browser — nothing is uploaded. Optional experimental post-quantum recipient encryption.' as const;

export const SITE_KEYWORDS =
  'ZeroCrypt, file encryption, text encryption, browser encryption, Argon2id, AES-256-GCM, privacy, local encryption, post-quantum, Pentaframe, client-side crypto' as const;

export const FILE_EXTENSION = '.zerocrypt' as const;
export const FILE_MIME = 'application/vnd.zerocrypt' as const;
export const FORMAT_VERSION = 1 as const;
export const TEXT_PREFIX = 'ZC1:' as const;
